exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center-content[data-v-83cd3266] {\n  margin: auto;\n}\ntable[data-v-83cd3266] {\n  background-color: rgb(118,118,118);\n}\n.link[data-v-83cd3266] {\n  color: #a6192e;\n  margin: auto;\n}\n#snow-zone-button[data-v-83cd3266] {\n  padding-top: 0px;\n}\n", ""]);

// exports
